import { isEqual } from 'underscore';
import { isSameAttendee } from '@shoflo/studio-redux/utils/actionUtils';
import setProgram from './setProgram';

function syncProgram({ program: updatedProgram, notifyingDirector }) {
  return (dispatch, getState) => {
    const state = getState();
    const { program } = state;
    if (!isEqual(program, updatedProgram)) {
      if (!isSameAttendee(notifyingDirector, state)) {
        dispatch(setProgram(updatedProgram, true, { emitSocket: false }));
      }
    }
  };
}

export default syncProgram;
